import toUpper from 'lodash/toUpper'
import get from 'lodash/get'

const parseParams = ({ params = {}, options = {} } = {}) => {
  return {
    value: get(params, 'value') || get(params, 'param') || ''
  }
}

export default (args) => {
  const { value } = parseParams(args)
  return toUpper(value)
}

const humanizeCall = (args) => {
  return 'Uppercase Text'
}

export {
  humanizeCall
}
